// src/components/dashboard/departmentadmin/TrainingHoursChart.js
import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import DashboardCard from '../DashboardCard';

function TrainingHoursChart({ data, loading }) {
  return (
    <DashboardCard
      title="Training Hours: Actual vs Planned"
      icon="bi-clock-history"
      loading={loading}
      isEmpty={!loading && data.length === 0}
      emptyMessage="No training hours data yet."
    >
      <div style={{ width: '100%', height: 260 }}>
        <ResponsiveContainer>
          <BarChart data={data}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="month" />
            <YAxis allowDecimals={false} />
            <Tooltip />
            <Legend />
            <Bar dataKey="planned" fill="#6c757d" name="Planned Hours" />
            <Bar dataKey="actual" fill="#198754" name="Actual Hours" />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </DashboardCard>
  );
}

export default TrainingHoursChart;
